import CityPage from "../CityPage";

export default function Crestwood() {
  return <CityPage slug="crestwood" />;
}
